
const imageUrl = (title) => {
  return `/imgs/case/bulk/${title}.png`;
};

const data = {
  introduce: {
    img: imageUrl('introduce')
  },
  method: imageUrl('method'),
  value: [
    {
      title: '支撑公司组织变革',
      items: [
        '实现业务、信息互联，物流网点变成网络。',
        '统一财务结算的实施，实现业务财务一体化管理，信息系统成为管理抓手。'
      ]
    },
    {
      title: '客户增长快速上升',
      items: [
        '打造“大平台，小前端”的经营框架，由统一的窗口服务客户，提升品牌形象和客户体验。',
        '构建企业级的控制塔，大平台统一下达作业指令，小前端按指令作业，很好的控制经营风险。'
      ]
    },
    {
      title: '降低成本提高效率',
      items: [
        '物流的上线，结束了纸质、电话的传统业务模式，在业务量上升30%的情况下，未增加人员。',
        '客户、供应商协同的上线以及系统的对接，使数据采集的效率提升50%，大幅提升运营效率。'
      ]
    },
    {
      title: '链接内外部资源打造大物流体系',
      items: [
        '构建协同门户，打造客户、物流提供商和内外部供应商的协同物流体系。',
        '实施SRM体系，管理供应商的准入、配额和KPI等，整合优质的资源服务社会。',
        '为供应链金融、保险、车后服务等增值服务的延伸奠定基础。'
      ]
    }
  ]
};

export default data;


// WEBPACK FOOTER //
// ./src/routes/Case/config/bulk.js